import type {
	Content, DocumentTitle, Vector
} from '@types'
import axios from 'axios'

import env from '../environments'

export async function deleteContent(brainId: string, contentId: string) {
	await axios.delete(`${env.apiUrl}/contents/${brainId}/${contentId}`)
}

export async function getUploads() {
	const response = await axios.get(`${env.apiUrl}/contents/uploads`)

	return response.data as {uploads: Content[]}
}

export async function dismissContent(contentIds: string[], integrationIds: string[]) {
	await axios.post(`${env.apiUrl}/contents/dismiss`, {
		contentIds,
		integrationIds
	})
}

export async function getVectorData(id: string, vectorId: string) {
	const response = await axios.get(`${env.apiUrl}/contents/${id}/${vectorId}`)

	return response.data as Vector
}

export async function getContentData(id: string) {
	const response = await axios.get(`${env.apiUrl}/contents/${id}/data`)

	return response.data as Vector[]
}

export async function getContentParentFolderUrl(id: string) {
	const response = await axios.get(`${env.apiUrl}/contents/${id}/folder`)

	return response.data as string
}

export async function getContentByUrl(url: string, accessToken?: string | undefined) {
	let headers

	if (accessToken) {
		headers = {
		// eslint-disable-next-line @typescript-eslint/naming-convention
			Authorization: 'Bearer ' + accessToken
		}
	}

	const result = await axios.get(env.contentApiUrl + '/contents', {
		headers,
		params: {
			url
		}
	})

	return result.data as Content
}

export async function getDocuments(data: string, brainsIds: string[]) {
	const response = await axios.post(
		`${env.apiUrl}/contents/documents`,
		{ query: data, brainsIds }
	)

	return response.data as DocumentTitle[]
}

export async function getDocumentsByBrains(ids: string[]) {
	const response = await axios.post(
		`${env.apiUrl}/contents/documentsbybrains`,
		{ brainsIds: ids }
	)

	return response.data as DocumentTitle[]
}

export async function getSummaryAndTitle(id: string) {
	const response = await axios.post(
		`${env.apiUrl}/contents/summary-and-title`,
		{ contentId: id }
	)

	return response.data as {summary?: string | undefined; title?: string | undefined}
}
